import Translations from "@translate/components/Member/shared/planDisplayUtils";
import { I18nUtil } from "@utils/i18n";
import { MemberProductLevelEnum } from "@features/api/memberApi";
import { ProductPayCycle } from "../CurrentPlan/constants";

const I18n = I18nUtil.createScoped(Translations);

/** 前端统一展示名：Pro / Expert 老用户均翻译为 Ed Complete */
export const getDisplayPlanName = (
  level?: MemberProductLevelEnum,
  forceComplete?: boolean,
): string => {
  if (forceComplete) {
    return I18n.t("Ed Complete");
  }

  if (!level || level === MemberProductLevelEnum.FREE) {
    return I18n.t("Free");
  }

  return I18n.t("Ed Complete");
};

/** 前端统一展示名：Pro / Expert 老用户的 badge 均翻译为 Complete */
export const getDisplayBadgeName = (level?: MemberProductLevelEnum): string => {
  if (!level || level === MemberProductLevelEnum.FREE) {
    return "";
  }
  return I18n.t("Complete");
};

export const getPayCyclePillLabel = (
  payCycle?: string,
  isTrial?: boolean,
): string => {
  if (isTrial) {
    return I18n.t("Trial");
  }
  switch (payCycle) {
    case ProductPayCycle.WEEK:
      return I18n.t("Weekly");
    case ProductPayCycle.MONTH:
      return I18n.t("Monthly");
    case ProductPayCycle.YEAR:
      return I18n.t("Annual");
    case ProductPayCycle.LIFETIME:
      return I18n.t("Lifetime");
    default:
      return I18n.t("Annual");
  }
};
